"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var LicensingAdminContext = /*#__PURE__*/(0, _react.createContext)({
  productList: [],
  selectedProduct: null,
  selectedCourse: null,
  selectedDeployment: null,
  fetchProducts: function fetchProducts() {},
  setProductList: function setProductList() {},
  setSelectedProduct: function setSelectedProduct() {},
  setSelectedCourse: function setSelectedCourse() {},
  setSelectedDeployment: function setSelectedDeployment() {}
});
var _default = exports["default"] = LicensingAdminContext;